import {AxiosResponse} from 'axios'
import axiosApi from '../api/axios-api'

export default {
    companyReportHistoryViewLast(id: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreporthistory/last/` + id, null)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
}
